import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { deleteArchiveDataModalData } from '@app/mpp/model/delete-archive-model';
import { mppRecipeCard } from '@app/mpp/model/recipe-card-model';
import { PlatformEnum } from '@panamax/app-state';

@Component({
  selector: 'app-delete-mpp-confirmation-modal',
  templateUrl: './delete-mpp-confirmation-modal.component.html',
  styleUrls: [
    './delete-mpp-confirmation-modal.component.scss',
    '../../../../styles/shared-mpp-styles.scss',
  ],
})
export class DeleteMppConfirmationModalComponent {
  @Output() dismissEvent: EventEmitter<void> = new EventEmitter();
  @Output() submitEvent: EventEmitter<string[]> = new EventEmitter();
  @Input() platform: PlatformEnum;
  @Input() data: deleteArchiveDataModalData;

  platformRef = PlatformEnum;
  constructor() {}

  dismiss() {
    this.dismissEvent.emit();
  }

  submit() {
    this.submitEvent.emit(this.data.selectedIds);
  }
}
